import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { Box, Divider } from '@mui/material';
import { Formik } from 'formik';
import { ComponentType, PropsWithChildren } from 'react';
import { FormContainer } from 'react-hook-form-mui';
import { useReportCtx } from '../report-ctx';
import { ReportActions } from './actions/formik/ReportActions';
import { ReportActionsRhf } from './actions/rhf/ReportActionsRhf';

export type FormLibrary = 'formik' | 'react-hook-form';

/**
 * Report form wrapped in PageToolbar with DataToolbar-style layout:
 * form content, divider, then actions bar.
 */
export const ReportForm = ({
  children,
  Actions = ReportActions,
  formLibrary = 'formik',
}: PropsWithChildren<{
  Actions?: ComponentType;
  horizontal?: boolean;
  formLibrary?: FormLibrary;
}>) => {
  const ctx = useReportCtx();

  if (formLibrary === 'react-hook-form') {
    return (
      <FormContainer values={ctx.values} onSuccess={(values) => ctx.runReport(values)}>
        <PageToolbar>
          <Box>{children}</Box>
          <Divider sx={{ my: 1.25 }} />
          <ReportActionsRhf />
        </PageToolbar>
      </FormContainer>
    );
  }

  return (
    <Formik initialValues={ctx.values} onSubmit={(values) => ctx.runReport(values)}>
      <PageToolbar>
        <Box>{children}</Box>
        <Divider sx={{ my: 1.25 }} />
        <Actions />
      </PageToolbar>
    </Formik>
  );
};
